import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { SearchParameters } from '../_viewmodels/search-params.viewmodel';
import { TramiteAfiliado } from '../_models/tramite-afiliado.model';
import { CertificadoAfiliado } from '../_models/certificado-afiliado.model';
import { API_REQUEST } from '../_models/request.model';
import { AuthenticationService } from './authentication.service';
import { User } from '../_models/user.model';
import { EnvironmentService } from './environment.service';
import { CertificadoMasivo } from '../_models/certificado-masivo.model';
import { CertificadoMasivoDetalle } from '../_models/certificado-masivo-detalle.model';

@Injectable()
export class SearchService {
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    private environmentService: EnvironmentService
  ) { }

  searchTramites(searchParameters: SearchParameters) {
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      options = {
        headers: new HttpHeaders().append(
          'Authorization',
          `Bearer ${user.authToken}`
        ).append('Access-Control-Allow-Origin','*'),
      };
    } else {
      options = {};
    }
    return this.http
      .post(
        `${this.environmentService.apiUrl}/Consultas`,
        searchParameters,
        options
      )
      .pipe(
        map((tramites: TramiteAfiliado[]) => {
          return tramites;
        })
      );
  }

  search_all(body) {
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      options = {
        headers: new HttpHeaders().append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
      };
    } else {
      options = {};
    }
    return this.http
      .post(
        `${this.environmentService.apiUrl}/Reportes/Postafiliados_tramites_all`,
        body,
        options
      )
      .pipe(
        map((tramites: API_REQUEST) => {
          return tramites;
        })
      );
  }

  searchCertificados(searchParameters: SearchParameters) {
    // console.log(searchParameters);
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      // console.log('%c' +user.authToken, 'color: red;');
      options = {
        headers: new HttpHeaders().append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
      };
    } else {
      options = {};
    }
    return this.http
      .post(
        `${this.environmentService.apiUrl}/ConsultasCertificados`,
        searchParameters,
        options
      )
      .pipe(
        map((certificados: CertificadoAfiliado[]) => {
          return certificados;
        })
      );
  }
  searchCertificadosMasivos(searchParameters: SearchParameters) {
    // console.log(searchParameters);
    const user: User = this.authService.currentUserValue;
    let options = {};
    if (user && user.authToken) {
      // console.log('%c' +user.authToken, 'color: red;');
      options = {
        headers: new HttpHeaders().append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
      };
    } else {
      options = {};
    }
    return this.http
      .post(
        `${this.environmentService.apiUrl}/ConsultasCertificadosMasivos`,
        searchParameters,
        options
      )
      .pipe(
        map((certificados: CertificadoMasivo[]) => {
          return certificados;
        })
      );
  }
  searchCertificadoMasivo(tocid: string){
    const user: User = this.authService.currentUserValue;
    const parameter = {
      "tocid": tocid
    };
    let options = {};
    if (user && user.authToken) {
      // console.log('%c' +user.authToken, 'color: red;');
      options = {
        headers: new HttpHeaders().append(
          'Authorization',
          `Bearer ${user.authToken}`
        ),
      };
    } else {
      options = {};
    }
    return this.http
      .get(
        `${this.environmentService.apiUrl}/ConsultasCertificadosMasivos?tocid=${tocid}`,
        options
      )
      .pipe(
        map((certificados: CertificadoMasivoDetalle[]) => {
          return certificados;
        })
      );
  }
}
